import * as base from '../core/BaseServices';

//service uri
const servicetemplate= 'Patient/PatientScreeningList'
const getAllServiceTemplate = (queryString) => base.get(`${servicetemplate}${queryString}`);
export default getAllServiceTemplate;